import httpService from '../httpService';
import { APIResponse } from '@/types';
import { LayoutPackageResponse } from '@/types/pages/storeManagement/layout';

export const fetchLayoutPackageByStoreAPI = async (
    corporateId: number,
    storeId: number,
): Promise<APIResponse<LayoutPackageResponse>> => {
    return httpService.get(`/layout-package/${corporateId}/store/${storeId}`);
};
